var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"full-product-box"},[_c('CartItemView',{attrs:{"cart-item":_vm.cartItem,"checkout":_vm.checkout,"save-handler":_vm.mappedSaveHandler,"webshop":_vm.webshop,"old-item":_vm.oldItem,"admin":_vm.admin}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }